/**
 * Cdn Url Formatter.
 * @param {*} value
 * @param {Object} row
 * @returns {String|*}
 */
window.cdnUrlFormatter = function(value, row) {
    let html = '';
    if (row.original_type == "file" && row.url) {
        html += '<a href="'+row.url+'" target="_index">';
        html += '<i class="fal fa-external-link"></i>';
        html += '</a>';
    }
    return html;
};
